<template>
    <a class="flex flex-nowrap rounded-lg px-6 py-8 shadow-md hover:bg-[var(--hover-gray)]"
        :href="href || `/integrations${integration.type ? '/' + integration.type : ''}${query ? '?' + query : ''}`"
        :title="integration.name">
        <div :class="justImage ? '' : 'flex-none w-12'" v-if="integration.logo_url">
            <img :src="integration.logo_url" @error="onLogoError" :title="integration.name" :alt="integration.name"
                class="w-full max-h-12 object-left-top object-contain rounded" />
        </div>
        <div :class="justImage ? 'flex-none w-12' : ''" v-if="!integration.logo_url && integration.fa_icon">
            <Icon :name="integration.fa_icon" class="text-4xl text-gray-400" />
        </div>
        <div :class="['overflow-hidden w-auto ml-6', hideLabels ? 'flex items-center' : '']" v-if="!justImage">
            <p class="font-semibold box-title">{{ integration.name }}</p>

            <div v-if="!hideLabels" class="flex flex-wrap">
                <Badge color="gray" :label="MAP_CATS[cat as keyof typeof MAP_CATS] || ''"
                    v-for="cat in integration.categories.filter((c) => MAP_CATS[c as keyof typeof MAP_CATS])"
                    class="mr-1 mb-1" />
                <Badge label="New" v-show="integration.recent" color="blue" icon="material-symbols:star"
                    class="mr-1 mb-1" />
                <Badge label="Request" v-show="!integration.created_at" color="gray" class="mr-1 mb-1" />
            </div>
        </div>
    </a>
</template>

<script lang="ts">
import { onLogoError } from '~/composables/useLogoFallback';
import { type PropType } from 'vue';
import { type IIntegration2 } from '~~/services/integrations';
import { MAP_CATS } from '~~/services/categories';

export default {
    methods: { onLogoError },
    props: {
        integration: {
            type: Object as PropType<IIntegration2>,
            required: true,
        },
        justImage: Boolean,
        hideLabels: Boolean,
        query: String,
        href: String,
    },
    data() {
        return {
            MAP_CATS,
        };
    },
};
</script>